class BulkOrderDrawer extends HTMLElement {
    constructor() {
        super();

        const __bulkOrderDrawer = this;
        const __bulkOrderDrawerOverlay = __bulkOrderDrawer.querySelector('#BulkOrderDrawer-Overlay');
        const __bulkOrderDrawerSubmit = __bulkOrderDrawer.querySelector('[data-bulk-order-drawer-submit]');

        __bulkOrderDrawerOverlay?.addEventListener('click', this.close.bind(this));
        __bulkOrderDrawerSubmit?.addEventListener('click', this.submit(this));

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    }
  
    close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    submit() {
        this.form = this.querySelector('form#ContactForm');
        this.fullNameInput = this.form.querySelector('input#ContactForm-name');
        this.emailInput = this.form.querySelector('input#ContactForm-email');
        this.companyNameInput = this.form.querySelector('input#ContactForm-company');
        this.deliveryDateInput = this.form.querySelector('input#ContactForm-date');
        this.hearAboutSelect = this.form.querySelector('select#bulkOrderDrawerHearSelect');
        this.commentTextarea = this.form.querySelector('textarea#ContactForm-body');

        let __lead = {
            fullName: this.fullNameInput.value,
            email: this.emailInput.value,
            companyName: this.companyNameInput.value, 
            desiredDeliveryDate: this.deliveryDateInput.value,
            hearAbout: this.hearAboutSelect.value,
            comment: this.commentTextarea.value
        }

        console.table(__lead);
    }
}
  
customElements.define('bulk-order-drawer', BulkOrderDrawer);

const __bulkOrderDrawer = document.querySelector('bulk-order-drawer[data-bulk-order-drawer]');
const __bulkOrderDrawerOpenTrigger = document.querySelectorAll('.button--bulk-drawer-trigger');

__bulkOrderDrawerOpenTrigger?.forEach(button => {
    button?.addEventListener('click', (ele) => {
        if(__bulkOrderDrawer) {
            __openBulkOrderDrawer__(__bulkOrderDrawer);
        } else if(document.querySelector('.globo-formbuilder .floating-button')) {
            document.querySelector('.globo-formbuilder .floating-button').click();
        }
    });
});

function __openBulkOrderDrawer__(drawer) {
    if(!drawer.classList.contains('active')) drawer.classList.add('active');
}